import { useNavigate } from "react-router-dom";
import "./Rewards.css";
import arrowLeft from "./../../assets/images/arrow-left.svg";
import walletRemove from "./../../assets/images/wallet-remove.svg";
import wallet2 from "./../../assets/images/wallet-2.svg";
import moneyRecive from "./../../assets/images/money-recive.svg";
import arrowRight from "./../../assets/images/chevron-right.svg";
import wallet from "./../../assets/images/wallet.png";
import profileUser from "./../../assets/images/profile-2user.svg";
import shoppingBag from "./../../assets/images/shopping-bag.svg";
import profit from "./../../assets/images/profit.svg";
import loss from "./../../assets/images/loss.svg";
import TabPane from "antd/es/tabs/TabPane";
import { Button, Spin, Tabs } from "antd";
import { useEffect, useState } from "react";
import RewardsQuestionPopup from "./components/RewardsQuestionPopup";
import BarChart from "./components/BarChart";
import {
  fetchEarnings,
  fetchMonetaryTrend,
  fetchPurchaseHistory,
  fetchReferredPatientCount,
} from "./service";
import useStore from "../../store/useStore";
import { MONTHS } from "../../utils/constants";
import dayjs from "dayjs";
import { fillMissingMonths } from "../../utils/helper";

const Rewards = () => {
  const navigate = useNavigate();
  const { doctorDetails } = useStore((state) => ({
    doctorDetails: state.doctorDetails,
  }));
  const commission = doctorDetails?.user?.commission || 0;
  const rewardsQuestions = [
    {
      title: "How Rewards are calculated",
      description: [
        `Your rewards are calculated as ${commission}% of the value of each care plan purchased by the patients you refer.`,
        `For example, if a patient you referred purchases a care plan worth ₹5,000, you will earn ₹${
          (commission / 100) * 5000 || 0
        } as your reward (which is ${commission}% of ₹5,000).`,
        "These rewards accumulate over time and can be a significant addition to your earnings.",
      ],
    },
    {
      title: "Withdrawal Process",
      description: [
        "To withdraw your accumulated rewards, please reach out to your Relationship Manager (RM). They will guide you through the process and ensure you receive your earnings promptly.",
      ],
    },
  ];
  const [earningData, setEarningData] = useState<any>({});
  const [purchaseHistoryData, setPurchaseHistoryData] = useState<any>({});
  const [monetaryTrend, setMonetaryTrend] = useState<any>([]);
  const [totalEarning, setTotalEarning] = useState<any>({});
  const [patientReferred, setPatientReferred] = useState<any>({});
  const [selectedQuestion, setSelectedQuestion] = useState<number | null>(null);
  const [activeTab, setActiveTab] = useState("thisMonth");
  const [loading, setLoading] = useState(false);
  const [totalPatientReferred, setTotalPatientReferred] = useState(0);
  const [patientReferredDifference, setPatientReferredDifference] = useState(0);

  const plansPurchased = Number(purchaseHistoryData?.difference) || 0;

  const patientReferredMonthWiseCount = patientReferred?.monthWiseCount;

  useEffect(() => {
    if (activeTab === "thisMonth") {
      setTotalPatientReferred(patientReferredMonthWiseCount?.[0]?.count);
      setPatientReferredDifference(
        patientReferredMonthWiseCount?.[0]?.count -
          patientReferredMonthWiseCount?.[1]?.count
      );
    } else if (activeTab === "previousMonth") {
      setTotalPatientReferred(patientReferredMonthWiseCount?.[1]?.count);
      setPatientReferredDifference(
        patientReferredMonthWiseCount?.[1]?.count -
          patientReferredMonthWiseCount?.[2]?.count
      );
    } else {
      setTotalPatientReferred(
        patientReferred?.lifeTimeCount?.totalPatientsReferred
      );
    }
  }, [activeTab, patientReferred]);

  useEffect(() => {
    if (doctorDetails?.user?.myT?.doctorId && activeTab !== "lifetime") {
      const today = dayjs();
      const payload = {
        startDate:
          activeTab === "thisMonth"
            ? today.date(1).format("YYYY-MM-DD")
            : today.subtract(1, "month").date(1).format("YYYY-MM-DD"),
        endDate:
          activeTab === "thisMonth"
            ? today.format("YYYY-MM-DD")
            : today.subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
        lifetime: false,
      };
      getEarnings(payload);
      getPurchaseHistory(payload);
    } else if (doctorDetails?.user?.myT?.doctorId && activeTab === "lifetime") {
      getPurchaseHistory({ lifetime: true });
    }
  }, [doctorDetails, activeTab]);

  useEffect(() => {
    if (doctorDetails?.user?.myT?.doctorId) {
      getTotalEarnings();
      getMonetaryTrend();
      getPatientReferred();
    }
  }, [doctorDetails]);

  const getPatientReferred = async () => {
    let patientReferredResponse = await fetchReferredPatientCount(
      doctorDetails?.user?.b2cId
    );
    if (patientReferredResponse?.monthWiseCount) {
      patientReferredResponse.monthWiseCount = fillMissingMonths(
        patientReferredResponse?.monthWiseCount
      );
    }
    while (patientReferredResponse?.monthWiseCount?.length < 3) {
      patientReferredResponse?.monthWiseCount.push({ count: 0 });
    }
    setPatientReferred(patientReferredResponse);
  };

  const getEarnings = async (payload: any) => {
    const earningsResponse = await fetchEarnings(
      doctorDetails?.user?.myT?.doctorId,
      payload
    );
    setEarningData(earningsResponse);
  };

  const getTotalEarnings = async () => {
    setLoading(true);
    const totalEarningResponse: any = await fetchEarnings(
      doctorDetails?.user?.myT?.doctorId,
      {
        lifetime: true,
      }
    );
    setTotalEarning(totalEarningResponse);
    setLoading(false);
  };

  const getPurchaseHistory = async (payload: any) => {
    const purchaseHistoryresponse = await fetchPurchaseHistory(
      doctorDetails?.user?.myT?.doctorId,
      payload
    );
    setPurchaseHistoryData(purchaseHistoryresponse);
  };
  const getMonetaryTrend = async () => {
    let monetaryTrendresponse = await fetchMonetaryTrend(
      doctorDetails?.user?.myT?.doctorId,
      {
        lifetime: true,
      }
    );
    if (
      monetaryTrendresponse?.length < 3 &&
      monetaryTrendresponse?.length > 0
    ) {
      monetaryTrendresponse = getFutureMonths(monetaryTrendresponse);
    }
    setMonetaryTrend(monetaryTrendresponse);
  };

  function getFutureMonths(data: any) {
    // Get the year and month from the last element of the data array
    let [currentYear, currentMonth] = data[data.length - 1]?.month
      .split("-")
      .map(Number);

    while (data.length < 3) {
      currentMonth++; // Increment the month

      // If month exceeds 12, reset to 1 and increment the year
      if (currentMonth > 12) {
        currentMonth = 1;
        currentYear++;
      }

      // Format the new month in "YYYY-MM" format and add to the data array
      const newMonth = `${currentYear}-${String(currentMonth).padStart(
        2,
        "0"
      )}`;
      data.push({ month: newMonth });
    }

    return data;
  }

  const backBtnHandler = () => {
    navigate("/remote-care");
  };
  const referBtnHandler = () => {
    navigate("/patient-condition");
  };

  const descriptionPopupHandler = (index: number) => {
    setSelectedQuestion(index);
  };

  const closePopup = () => {
    setSelectedQuestion(null);
  };

  return (
    <div>
      <div className="p-6 flex items-start font-semibold gap-x-2 pb-5 bg-[#FFFFFF] sticky top-0 z-10">
        <img src={arrowLeft} alt="arrowLeft" onClick={backBtnHandler} />
        <span>Your Rewards</span>
      </div>
      {loading ? (
        <Spin className="mt-16 flex items-center justify-center" />
      ) : totalEarning?.earnings && totalEarning?.earnings !== "0" ? (
        <div>
          <div
            className="bg-[#F9F9FF]"
            style={{ borderRadius: "0 0 42px 42px" }}
          >
            <Tabs
              className="flex w-full items-center custom-tab"
              activeKey={activeTab}
              onChange={(key) => {
                setActiveTab(key);
              }}
              tabBarStyle={{
                color: "#49454F",
              }}
              tabBarExtraContent={
                <div className="flex-1 h-[2px] bg-blue-600 !-mt-2" /> // Custom underline color using Tailwind
              }
            >
              <TabPane
                tab={
                  <span
                    className={`${
                      activeTab === "thisMonth"
                        ? "text-[#4B4AD5] font-semibold"
                        : "text-[#49454F] font-medium "
                    }`}
                  >
                    This Month
                  </span>
                }
                key="thisMonth"
              />
              <TabPane
                tab={
                  <span
                    className={`${
                      activeTab === "previousMonth"
                        ? "text-[#4B4AD5] font-semibold"
                        : "text-[#49454F] font-medium "
                    }`}
                  >
                    Previous Month
                  </span>
                }
                key="previousMonth"
              />
              <TabPane
                tab={
                  <span
                    className={`${
                      activeTab === "lifetime"
                        ? "text-[#4B4AD5] font-semibold"
                        : "text-[#49454F] font-medium "
                    }`}
                  >
                    Lifetime
                  </span>
                }
                key="lifetime"
              />
            </Tabs>

            <div
              className="px-6 pb-8 pt-2"
              style={{ borderRadius: "0 0 42px 42px", overflow: "hidden" }}
            >
              <div
                className="bg-no-repeat bg-center h-[168px] xs:h-[205px] w-full flex flex-col items-start p-6 pl-9 xs:pt-7 text-[#fff]"
                style={{
                  backgroundImage: `url(${wallet})`,
                  backgroundSize: "contain",
                }}
              >
                <div className="text-xs">
                  Your{" "}
                  <b>
                    {activeTab === "lifetime"
                      ? "Total"
                      : MONTHS[earningData?.month - 1]}
                  </b>{" "}
                  Earnings{" "}
                  {activeTab === "lifetime" ? (
                    <span>
                      {"(" +
                        dayjs()
                          .subtract(totalEarning.month - 1, "month")
                          .format("MMM YY") +
                        " - now)"}
                    </span>
                  ) : null}
                </div>
                <div className="text-3xl font-semibold">
                  ₹{" "}
                  {activeTab === "lifetime"
                    ? totalEarning.earnings
                    : earningData?.earnings}
                </div>
              </div>
              <div className="flex gap-6 pt-6">
                <div className="p-4 border border-[#DCE4E8] rounded-2xl flex flex-col gap-x-2 items-baseline justify-between bg-white min-h-[207px]">
                  <img src={profileUser} alt="close" />
                  <span className="text-[#5A6774] text-left pb-3 pt-2">
                    Total Patients Referred
                  </span>
                  <div className="flex justify-between items-center w-full">
                    <div className="flex flex-col items-start">
                      <span className="font-semibold text-2xl">
                        {totalPatientReferred || 0}
                      </span>
                      <span className="text-xs">Patients</span>
                    </div>
                    {patientReferredDifference && activeTab !== "lifetime" ? (
                      <div
                        className={`flex gap-x-1 py-[4px] px-[5px] ${
                          patientReferredDifference > 0
                            ? "bg-[#EDF7ED] text-[#3D8C40]"
                            : "bg-[#FCEDED] text-[#E54848]"
                        }`}
                        style={{ borderRadius: "5px" }}
                      >
                        {patientReferredDifference > 0 ? "+" : ""}
                        {patientReferredDifference}
                        <img
                          src={patientReferredDifference > 0 ? profit : loss}
                          alt="profitOrLoss"
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="p-4 border border-[#DCE4E8] rounded-2xl flex gap-x-2 flex-col items-baseline justify-between bg-white min-h-[207px]">
                  <img src={shoppingBag} alt="close" />
                  <span className="text-[#5A6774] text-left pb-3 pt-2">
                    Total Plan Purchased
                  </span>
                  <div className="flex justify-between items-center w-full">
                    <div className="flex flex-col items-start">
                      <span className="font-semibold text-2xl">
                        {purchaseHistoryData?.plansPurchased}
                      </span>
                      <span className="text-xs">Plans</span>
                    </div>
                    {plansPurchased && activeTab !== "lifetime" ? (
                      <div
                        className={`flex gap-x-1 py-[4px] px-[5px] ${
                          plansPurchased > 0
                            ? "bg-[#EDF7ED] text-[#3D8C40]"
                            : "bg-[#FCEDED] text-[#E54848]"
                        }`}
                        style={{ borderRadius: "5px" }}
                      >
                        {plansPurchased > 0 ? "+" : ""}
                        {plansPurchased}
                        <img
                          src={plansPurchased > 0 ? profit : loss}
                          alt="profitOrLoss"
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {monetaryTrend?.length && (
            <div className="p-6 pb-0">
              <BarChart
                monetaryTrend={monetaryTrend}
                patientReferred={patientReferred?.monthWiseCount}
              />
            </div>
          )}

          <div className="p-6 flex flex-col gap-y-4">
            <div className="font-semibold text-xl mt-5 text-left">
              Have more questions?
            </div>
            {rewardsQuestions.map((item: any, index: number) => {
              return (
                <div
                  className="p-4 border border-[#DCE4E8] rounded-2xl flex gap-x-2 items-center justify-between cursor-pointer"
                  style={{ width: "100%" }}
                  key={index}
                  onClick={() => descriptionPopupHandler(index)}
                >
                  <div className="font-semibold text-sm text-left text-[#1F2933] flex items-center gap-x-2">
                    <img
                      src={index === 0 ? wallet2 : moneyRecive}
                      alt="arrow-left"
                    />
                    {item?.title}
                  </div>
                  <img src={arrowRight} alt="arrowRight" />
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="p-6 h-screen bg-[#F9F9FF] overflow-hidden flex flex-col items-center">
          <img
            className="opacity-50"
            src={walletRemove}
            alt="walletRemove"
            onClick={backBtnHandler}
          />
          <div className="font-semibold text-2xl">No Rewards Earned yet!</div>
          <span className="text-sm text-center">
            Start recommending care plans to your patients and earn {commission}
            % rewards on each care plan purchased by the patients you referred
          </span>
          {/* <div className="mt-5 w-full">
            <Button
              type="primary"
              className="w-full h-14 rounded-2xl bg-[#4B4AD5] p-5 text-lg font-medium"
              onClick={referBtnHandler}
            >
              Refer Care Plan Now
            </Button>
          </div> */}
        </div>
      )}
      {selectedQuestion !== null ? (
        <RewardsQuestionPopup
          selectedQuestion={selectedQuestion}
          closePopup={closePopup}
        />
      ) : null}
    </div>
  );
};

export default Rewards;
